const map = {
	"./1.jpeg": 985,
	"./2.jpeg": 528,
	"./3.jpeg": 447,
	"./4.jpeg": 390,
	"./6.jpeg": 748,
	"./7.jpeg": 435,
	"./apneducacion.jpg": 816,
	"./lorem.png": 12
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;